// extracted by mini-css-extract-plugin
module.exports = {"count":"DraggablePopup_count__1PVzh","amount":"DraggablePopup_amount__1N6Cd"};